import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { Breadcrumb, BreadcrumbItem } from "reactstrap";
import { toast } from "react-toastify";
import { getUserInfo, getUserRolePermissions, getUsers } from '../../services/userServicer';
import Select from 'react-select';
import { getControls } from "src/services/controls";
import { useForm } from "react-hook-form";
import { MdOutlineDelete } from "react-icons/md";
import { createSurvey,fetchAllDataApi } from "src/services/question"
import { useNavigate } from 'react-router-dom';
import { jwtDecode } from "jwt-decode";
import "./surveys.css"
import i18n from "src/i18n";
const CreateSurvey = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [notAllowed, setNotAllowed] = useState(false);
  const [userPermissions, setUserPermissions] = useState<any>(null);

  const { register, handleSubmit, formState: { errors }, watch, setValue, trigger } = useForm();
  const [question, setQuestion] = useState({
    en_name: '',
    ar_name: '',
    en_description: '',
    ar_description: '',
    questions: [],
    users: []
  });

  const [usersOptions, setUsersOptions] = useState<any[]>([]);
  const [questionsOptions, setQuestionsOptions] = useState<any[]>([]);

  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;
    setQuestion((prev) => ({
      ...prev,
      [name]: value,
    }));
  };


 

  const onSubmit = async(data: any) => {
    const response = await createSurvey(question);
    if (response.success) {
      toast.success(response.message);
      navigate('/viewsurvey');
    } else {
      toast.error(response.message);
    }
    
  };


  const fetchUsers = async () => {
    try {
      const response: any = await getUsers("", 10000, 0);
       
      if (response && response.success) {
        const indexedData = response.data.map((user: any, idx: number) => ({
          value: user.id,
          label: user.name
        }));
        setUsersOptions(indexedData); 
      } else if (response && response.data.length === 0) {
        setUsersOptions([]);
        
      } else {
        toast.error("Failed to fetch users data");
      }
    } catch (error: any) {
      toast.error("Error fetching users data:", error);
    }
  };

  const fetchQuestions = async () => {
    try {
      const questions: any = await fetchAllDataApi();
      
        if (questions.success) {
        let questionsOptions = questions.data.map((question: any) => ({
          value: question.id,
          label: i18n.language === 'ar' ? question.question_ar : question.question_en
        }));
        setQuestionsOptions(questionsOptions);
      } else {
        toast.error(questions.message);
      }
    } catch (error: any) {
      toast.error(error.message);
    }
  };

 


  useEffect(() => {
    const fetchUserRolePermissions = async () => {
      try {
        const user = await getUserInfo();
        if (!user?.id) return;
        let userId =  user.id || "";
        const permissions = await getUserRolePermissions(userId);
        if (permissions.success) {
          const compliancePagePermission = permissions.data.permissions.find((permission: any) => permission.page === "compliances");
          if (compliancePagePermission) {
            setUserPermissions(compliancePagePermission.permissions);
            if (compliancePagePermission.permissions.show) {
              setNotAllowed(false);
            } else {
              setNotAllowed(true);
            }
          } else {
            toast.error(permissions.message);
          }
        }
      } catch (error: any) {
        toast.error(t("permissions.Error_fetching_user_role_permissions") + ":", error);
      }
    };

    fetchUserRolePermissions();
    fetchUsers();
    fetchQuestions();
  }, []);

  // Custom styles for react-select to reduce height
  const customSelectStyles = {
    control: (provided: any) => ({
      ...provided,
      minHeight: '50px',
    }),
    valueContainer: (provided: any) => ({
      ...provided,
      height: '40px',
      padding: '0 6px',
    }),
    input: (provided: any) => ({
      ...provided,
      margin: '0px',
    }),
    indicatorsContainer: (provided: any) => ({
      ...provided,
      height: '40px',
    }),
  };

  return (
    <div className="root">
      <Breadcrumb>
      
        <BreadcrumbItem>{t("surveys.Surveys")}</BreadcrumbItem>
      <span className="mx-2">/</span> 

        <BreadcrumbItem active className="text-orange">
          {t("surveys.Create Survey")}
        </BreadcrumbItem>
      </Breadcrumb>

      <h5 className="mb-lg">{t('surveys.Create Survey')}</h5>
      {!notAllowed && <div className="container_info bg-white rounded p-4">
        <form onSubmit={handleSubmit(onSubmit)} className="create-compliance-form">
          <div className="form-section2  ">
            <h5 className="section-title">{t('surveys.BasicInfo')}</h5>
<div className="form-row">
              <div className="form-group flex-item">
              <label>{t('surveys.NameEn')}</label>
              <input
                type="text"
                value={question.en_name}
                placeholder={t('surveys.NameEnPlaceholder') || ''}
                className="form-control"
                {...register("en_name", { required: true })}
                onChange={handleInputChange}
              />
              {errors.en_name && <span className="text-danger">{t('This field is required')}</span>}
            </div>
            <div className="form-group flex-item">
              <label>{t('surveys.NameAr')}</label>
              <input
                type="text"
                value={question.ar_name}
                placeholder={t('surveys.NameArPlaceholder') || ''}
                className="form-control"
                {...register("ar_name", { required: true })}
                onChange={handleInputChange}
              />
              {errors.ar_name && <span className="text-danger">{t('This field is required')}</span>}
            </div>
</div>
<div className="form-row">


            <div className="form-group flex-item">
              <label>{t('surveys.en_description')}</label>
              <input
                type="text"
                value={question.en_description}
                placeholder={t('surveys.en_description_placeholder') || ''}
                className="form-control"
                {...register("en_description", { required: true })}
                onChange={handleInputChange}
              />
              {errors.en_description && <span className="text-danger">{t('This field is required')}</span>}
            </div>
            <div className="form-group flex-item">
              <label>{t('surveys.ar_description')}</label>
              <input
                type="text"
                value={question.ar_description}
                placeholder={t('surveys.ar_description_placeholder') || ''}
                className="form-control"
                {...register("ar_description", { required: true })}
                onChange={handleInputChange}
              />
              {errors.ar_description && <span className="text-danger">{t('This field is required')}</span>}
            </div>
</div>
            
          </div>

          <div className="form-row">
  <div className="flex-item">
            <h5 className="section-title">{t('surveys.questions')}</h5>

            <div className="form-group">
              <label className="form-label">{t("surveys.questions")}</label>
              <Select
                options={questionsOptions}
                isMulti={true}
                className="basic-single"
                classNamePrefix="select"
                styles={customSelectStyles}
                {...register("questions")}
                onChange={(selectedOptions: any) => {
                  setQuestion((prev) => ({
                    ...prev,
                    questions: selectedOptions ? selectedOptions.map((option: any) => option.value) : []
                  }));
                  setValue("questions", selectedOptions ? selectedOptions.map((option: any) => option.value) : []);
                  trigger("questions");
                }}
              />
            </div>

          </div>

          <div className="  flex-item">
            <h5 className="section-title">{t('surveys.users')}</h5>


            <div className="form-group">
              <label className="form-label">{t("surveys.users")}</label>
              <Select
                options={usersOptions}
                isMulti={true}
                className="basic-single"
                classNamePrefix="select"
                styles={customSelectStyles}
                {...register("users")}
                onChange={(selectedOptions: any) => {
                  setQuestion((prev) => ({
                    ...prev,
                    users: selectedOptions ? selectedOptions.map((option: any) => option.value) : []
                  }));
                  setValue("users", selectedOptions ? selectedOptions.map((option: any) => option.value) : []);
                  trigger("users");
                }}
              />
            </div>
           
          </div>
          </div>

         <div className="d-flex">
  <button type="submit" className="btn-create ms-auto">
    {t("surveys.Create Survey")}
  </button>
</div>
        </form>
      </div>}

      {notAllowed && <div className="container_info">
        <div className="d-flex justify-content-between my-2 text-center alert alert-danger">
          <h5 style={{ width: '100%' }} className="text-center">{t("permissions.not_allowed")}</h5>
        </div>
      </div>}
    </div>
  );
};

export default CreateSurvey;